import { memo } from 'react';
import { Dialog } from 'react-aria-components';

import { Modal, ModalOverlay } from '@/components/core';

import { InviteMembers, InviteMembersProps } from './InviteMembers';

export type InviteMembersModalProps = InviteMembersProps;

// eslint-disable-next-line no-empty-pattern
const IInviteMembersModal = ({ ...rest }: InviteMembersModalProps) => {
  return (
    <ModalOverlay>
      <Modal>
        <Dialog className="outline-none">
          {({ close }) => <InviteMembers className="p-md w-[25rem]" close={close} {...rest} />}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};

export const InviteMembersModal = memo(IInviteMembersModal) as typeof IInviteMembersModal;
